import { Color } from '../lib/modelBuilder/entities/Color';

class ItemPicker {
  _name?: string;
  _imgSrc?: string;
  color?: Color;

  constructor(name?: string, imgSrc?: string, color?: Color) {
    if (name) this._name = name;
    if (imgSrc) this._imgSrc = imgSrc;
    if (color) this.color = color;
  }

  get name() {
    if (this.color) {
      return this.color.name;
    } else if (this._name) {
      return this._name;
    }
    return undefined;
  }

  get imgSrc() {
    return this._imgSrc;
  }
}

export default ItemPicker;
